import uniq from 'lodash-es/uniq';
import {
    StrollersBrandsLoadApiFailureAction,
    StrollersBrandsLoadApiRequestAction,
    StrollersBrandsLoadApiSuccessAction,
    STROLLERS_BRANDS_LOAD_API_FAILURE,
    STROLLERS_BRANDS_LOAD_API_REQUEST,
    STROLLERS_BRANDS_LOAD_API_SUCCESS,
} from 'mk2/apps/strollers/containers/Brands/Brands.actions';
import { errorMessage } from 'mk2/reducers/errorMessage';
import { loadingState, LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

type BrandsActions =
    | StrollersBrandsLoadApiRequestAction
    | StrollersBrandsLoadApiSuccessAction
    | StrollersBrandsLoadApiFailureAction;

export interface State {
    brandIds: number[];
    strollersCountPerBrand: Record<number, number>;
    loadingState: LoadingState;
    errorMessage: string;
    hasMore: boolean;
}

export const initialState: State = {
    brandIds: [],
    strollersCountPerBrand: {},
    loadingState: LoadingState.INIT,
    errorMessage: null,
    hasMore: false,
};

const reducer: Reducer<State, BrandsActions> = (state = initialState, action) => {
    switch (action.type) {
        case STROLLERS_BRANDS_LOAD_API_REQUEST:
        case STROLLERS_BRANDS_LOAD_API_FAILURE:
            return {
                ...state,
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            };
        case STROLLERS_BRANDS_LOAD_API_SUCCESS:
            return {
                ...state,
                brandIds: uniq([...state.brandIds, ...action.response.result.brands]),
                hasMore: action.hasMore,
                strollersCountPerBrand: {
                    ...state.strollersCountPerBrand,
                    ...action.strollersCountPerBrand,
                },
                loadingState: loadingState(state.loadingState, action),
                errorMessage: errorMessage(state.errorMessage, action),
            };
        default:
            return state;
    }
};

export default reducer;
